(function (root, factory) {
  var helpers = factory();

  root.LineGroupChatHelpers = helpers;

  if (typeof module !== "undefined" && module.exports) {
    module.exports = helpers;
  }
})(typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : this, function () {
  var ANONYMOUS_LABEL = (typeof lang !== "undefined" && lang?.__anonymous) || "Anonymous";
  var LINE_OA_LABEL = "LINE OA";
  var LINE_OA_INACTIVE_STATUS = "N";
  var LINE_GROUP_TYPE = "group";
  var MAX_OUTGOING_MENTIONS = 20;

  function toArray(value) {
    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value.slice();
    }

    return Object.keys(value).map(function (key) {
      return {
        key: key,
        value: value[key],
      };
    });
  }

  function trimLabel(label) {
    return (label || "").toString().replace(/^@+/, "").trim();
  }

  function getSenderLookupId(sendBy) {
    if (!sendBy) {
      return "";
    }

    if (typeof sendBy === "object") {
      return (
        sendBy.sender_profile_id ||
        sendBy.senderProfileId ||
        sendBy.member_profile_id ||
        sendBy.memberProfileId ||
        sendBy.profile_id ||
        sendBy.profileId ||
        sendBy.send_by ||
        sendBy.sender ||
        sendBy.userId ||
        sendBy.user_id ||
        ""
      );
    }

    return sendBy.toString();
  }

  function getRawMembers(roomStatus) {
    if (!roomStatus) {
      return [];
    }

    return roomStatus.group_members || [];
  }

  function getRawLeftMembers(roomStatus) {
    if (!roomStatus) {
      return [];
    }

    return roomStatus.left_group_members || [];
  }

  function getLineOAStatus(roomStatus) {
    var summary = (roomStatus && roomStatus.chat_summary) || {};
    var status =
      roomStatus &&
      (roomStatus.line_oa_status ||
        roomStatus.lineOAStatus ||
        summary.line_oa_status ||
        summary.lineOAStatus ||
        "");

    return (status || "").toString().trim().toUpperCase();
  }

  function isLineOAActive(roomStatus) {
    var status = getLineOAStatus(roomStatus);
    return status !== '' && status !== LINE_OA_INACTIVE_STATUS;
  }

  function normalizeMember(member, key, index) {
    var source = member || {};
    var isLineOA = !!(source.is_line_oa || source.isLineOA);
    var resolvedProfileId =
      source.member_profile_id ||
      source.memberProfileId ||
      source.profile_id ||
      source.profileId ||
      source.id ||
      (typeof key === "string" && key ? key : "") ||
      "";
    var displayName = trimLabel(
      source.displayname ||
        source.display_name ||
        source.name ||
        [source.firstname, source.lastname].filter(Boolean).join(" ").trim() ||
        source.nickname ||
        source.full_name ||
        source.fullName ||
        ""
    );
    var isAnonymous =
      !!source.anonymous ||
      typeof source.anonymous_index !== "undefined" ||
      typeof source.anonymousIndex !== "undefined" ||
      displayName === ANONYMOUS_LABEL ||
      displayName === "Anonymous";
      var normalizedAnonymousIndex =
        typeof source.anonymous_index !== "undefined"
          ? source.anonymous_index
          : source.anonymousIndex;
    var resolvedUserId =
      source.userId ||
      source.user_id ||
      source.userID ||
      source.line_user_id ||
      source.lineUserId ||
      "";
    var avatar =
      source.img_profile ||
      source.picture_url ||
      source.pictureUrl ||
      source.avatar ||
      source.avatar_url ||
      source.photo_url ||
      source.profile_image_url ||
      "";

    return Object.assign({}, source, {
      memberKey:
        key ||
        source.memberKey ||
        source.member_profile_id ||
        source.memberProfileId ||
        source.profile_id ||
        source.profileId ||
        source.id ||
        index,
      displayName:
        isAnonymous ? '' : (displayName || (isLineOA ? LINE_OA_LABEL : '')),
      avatar: avatar,
      userId: resolvedUserId,
      memberProfileId: resolvedProfileId,
      profileId: resolvedProfileId,
      isLineOA: isLineOA,
      anonymous: isAnonymous,
      anonymousIndex: normalizedAnonymousIndex,
    });
  }

  function normalizeMembers(roomStatus) {
    var members = getRawMembers(roomStatus);
    var normalized = [];
    var lineOAActive = isLineOAActive(roomStatus);

    toArray(members).forEach(function (entry, index) {
      if (!entry) {
        return;
      }

      if (entry.value) {
        normalized.push(normalizeMember(entry.value, entry.key, index));
        return;
      }

      normalized.push(normalizeMember(entry, entry.memberKey || entry.id, index));
    });

    return normalized.filter(function (member) {
      return lineOAActive || !member.isLineOA;
    });
  }

  function normalizeLookupMembers(roomStatus) {
    var leftMembers = getRawLeftMembers(roomStatus);
    var normalized = normalizeMembers(roomStatus);
    var lineOAActive = isLineOAActive(roomStatus);

    toArray(leftMembers).forEach(function (entry, index) {
      if (!entry) {
        return;
      }

      if (entry.value) {
        normalized.push(normalizeMember(entry.value, entry.key, index));
        return;
      }

      normalized.push(normalizeMember(entry, entry.memberKey || entry.id, index));
    });

    return normalized.filter(function (member) {
      return lineOAActive || !member.isLineOA;
    });
  }

  function createAllMentionMember() {
    return {
      key: "@all",
      memberKey: "@all",
      displayName: "all",
      displayText: "all",
      userId: "",
      type: "all",
      all: true,
      memberProfileId: "all",
      profileId: "all",
    };
  }

  function isLineGroupRoom(roomStatus) {
    return !!(
      roomStatus &&
      roomStatus.line_group_id
    );
  }

  function isLineDirectRoom(roomStatus) {
    return !!(
      roomStatus &&
      roomStatus.line_user_id &&
      !isLineGroupRoom(roomStatus)
    );
  }

  function isLineRoom(roomStatus) {
    return !!(
      roomStatus &&
      (roomStatus.line_bot_id ||
        roomStatus.line_user_id ||
        roomStatus.line_group_id)
    );
  }

  function decorateRoomType(roomStatus) {
    if (!roomStatus) {
      return roomStatus;
    }

    roomStatus.isLineGroupRoom = isLineGroupRoom(roomStatus);
    roomStatus.isLineDirectRoom = isLineDirectRoom(roomStatus);
    roomStatus.isLineRoom = isLineRoom(roomStatus);

    return roomStatus;
  }

  function getMemberDisplayName(member, fallbackLabel) {
    var firstName = member && member.firstname;
    var lastName = member && member.lastname;
    var fullName = [firstName, lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    var displayName = member && member.displayName;

    return fullName || displayName || fallbackLabel || ANONYMOUS_LABEL;
  }

  function getMentionDisplayName(member) {
    return (
      trimLabel(
        getMemberDisplayName(
          member,
          (member &&
            (member.displayName ||
              member.displayname ||
              member.display_name ||
              member.name)) ||
            ANONYMOUS_LABEL
        )
      ) || ANONYMOUS_LABEL
    );
  }

  function decorateMentionMember(member) {
    var mentionDisplayName = getMentionDisplayName(member);
    var originalDisplayName = trimLabel(
      (member &&
        (member.displayName ||
          member.displayname ||
          member.display_name ||
          member.name)) ||
        ""
    );

    return Object.assign({}, member, {
      displayName: mentionDisplayName,
      mentionSearchLabel: trimLabel(
        [mentionDisplayName, originalDisplayName].filter(Boolean).join(" ")
      ),
    });
  }

  function getMemberAvatar(member) {
    return (member && member.avatar) || "";
  }

  function isAnonymousMember(member) {
    if (!member) {
      return false;
    }

    return (
      !!member.anonymous ||
      typeof member.anonymousIndex !== "undefined" ||
      typeof member.anonymous_index !== "undefined" ||
      member.displayName === ANONYMOUS_LABEL
    );
  }

  function isLineOAMember(member) {
    if (!member) {
      return false;
    }

    return !!member.isLineOA || member.displayName === LINE_OA_LABEL;
  }

  function getMemberProfileId(member) {
    if (!member) {
      return "";
    }

    return (
      member.profileId ||
      member.memberProfileId ||
      member.member_profile_id ||
      member.userId ||
      member.user_id ||
      member.id ||
      ""
    );
  }

  function getMentionUserId(member) {
    if (!member) {
      return "";
    }

    return (
      member.userId ||
      member.user_id ||
      member.userID ||
      member.line_user_id ||
      member.lineUserId ||
      ""
    );
  }

  function findMemberInListByProfileId(members, profileId) {
    var targetId = (profileId || "").toString();

    if (!targetId) {
      return null;
    }

    return (
      members.find(function (member) {
        return getMemberProfileId(member).toString() === targetId;
      }) || null
    );
  }

  function findCurrentMemberByProfileId(roomStatus, profileId) {
    return findMemberInListByProfileId(normalizeMembers(roomStatus), profileId);
  }

  function findMemberByProfileId(roomStatus, profileId) {
    return findMemberInListByProfileId(
      normalizeLookupMembers(roomStatus),
      profileId
    );
  }

  function mergeGroupMemberList(roomStatus, incomingMember) {
    var existingMembers = getRawMembers(roomStatus);
    var rawEntries = toArray(existingMembers);
    var mergedMembers = rawEntries.map(function (entry) {
      return entry && entry.value ? entry.value : entry;
    });
    var normalizedIncoming = normalizeMember(incomingMember);
    var incomingProfileId = getMemberProfileId(normalizedIncoming);
    var replaceIndex = -1;

    if (!incomingProfileId) {
      return mergedMembers;
    }

    replaceIndex = rawEntries.findIndex(function (entry) {
      var member = entry && entry.value ? entry.value : entry;
      var key = entry && entry.value ? entry.key : (entry && (entry.memberKey || entry.id));
      return getMemberProfileId(normalizeMember(member, key)).toString() === incomingProfileId.toString();
    });

    if (replaceIndex > -1) {
      mergedMembers[replaceIndex] = Object.assign(
        {},
        mergedMembers[replaceIndex] || {},
        incomingMember || {}
      );
      return mergedMembers;
    }

    var anonIndex = mergedMembers.findIndex(function (member) {
      return isAnonymousMember(member);
    });

    if (anonIndex > -1) {
      mergedMembers[anonIndex] = incomingMember;
      return mergedMembers;
    }

    mergedMembers.push(incomingMember);
    return mergedMembers;
  }

  function isSelectableGroupMember(member) {
    return (
      !!getMemberProfileId(member) &&
      !isAnonymousMember(member) &&
      !isLineOAMember(member)
    );
  }

  function isMentionableGroupMember(member) {
    return (
      !!getMentionUserId(member) &&
      !isAnonymousMember(member) &&
      !isLineOAMember(member)
    );
  }

  function getVisibleGroupMembers(roomStatus) {
    return normalizeMembers(roomStatus).filter(function (member) {
      return !isAnonymousMember(member);
    });
  }

  function getSelectableGroupMembers(roomStatus) {
    return normalizeMembers(roomStatus).filter(function (member) {
      return isSelectableGroupMember(member);
    });
  }

  function hasSelectableGroupMembers(roomStatus) {
    return getSelectableGroupMembers(roomStatus).length > 0;
  }

  function getLineGroupMemberCount(roomStatus) {
    var summary = (roomStatus && roomStatus.chat_summary) || {};
    var count =
      roomStatus &&
      (roomStatus.line_group_member_count || summary.line_group_member_count);

    count = Number(count);

    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function formatLineGroupRoomLabel(roomStatus, label) {
    var baseLabel = label || "";
    var count = getLineGroupMemberCount(roomStatus);

    if (!count) {
      return baseLabel;
    }

    return baseLabel + " (" + count + ")";
  }

  function findMemberBySendBy(roomStatus, sendBy) {
    var members = normalizeLookupMembers(roomStatus);
    var targetId = getSenderLookupId(sendBy);

    if (!targetId) {
      return null;
    }

    return (
      members.find(function (member) {
        var candidateIds = [
          member.userId,
          member.memberProfileId,
          member.profileId,
          member.member_profile_id,
          member.profile_id,
          member.memberKey,
          member.id,
          member.line_user_id,
          member.lineUserId,
        ]
          .filter(Boolean)
          .map(function (value) {
            return value.toString();
          });

        return candidateIds.indexOf(targetId) > -1;
      }) || null
    );
  }

  function getSenderDisplayName(roomStatus, sendBy, fallbackLabel) {
    var member = findMemberBySendBy(roomStatus, sendBy);

    if (member) {
      return getMemberDisplayName(member, fallbackLabel);
    }

    return fallbackLabel || ANONYMOUS_LABEL;
  }

  function getSenderInfo(roomStatus, sendBy, fallbackLabel) {
    var member = findMemberBySendBy(roomStatus, sendBy);
    var name = member && (member.firstname || member.displayName);
    return {
      displayName: name || fallbackLabel || ANONYMOUS_LABEL,
      avatar: getMemberAvatar(member)
    };
  }

  function getMentionableMembers(roomStatus, query) {
    if (!isLineGroupRoom(roomStatus)) {
      return [];
    }

    var normalizedQuery = (query || "").toString().trim().toLowerCase();
    var showAllMention = !normalizedQuery || normalizedQuery === "all";
    var members = normalizeMembers(roomStatus)
      .filter(function (member) {
        return isMentionableGroupMember(member);
      })
      .map(function (member) {
        return decorateMentionMember(member);
      })
      .filter(function (member) {
        if (!normalizedQuery) {
          return true;
        }

        var name = (member.mentionSearchLabel || member.displayName || "").toLowerCase();
        var userId = (member.userId || "").toLowerCase();

        return name.indexOf(normalizedQuery) > -1 || userId.indexOf(normalizedQuery) > -1;
      })
      .sort(function (a, b) {
        var queryLower = normalizedQuery;
        var aName = (a.displayName || "").toLowerCase();
        var bName = (b.displayName || "").toLowerCase();
        var aStarts = queryLower && aName.indexOf(queryLower) === 0;
        var bStarts = queryLower && bName.indexOf(queryLower) === 0;

        if (aStarts !== bStarts) {
          return aStarts ? -1 : 1;
        }

        return aName.localeCompare(bName, undefined, {
          sensitivity: "base",
        });
      });

    if (showAllMention) {
      return [createAllMentionMember()].concat(members);
    }

    return members;
  }

  function findMentionContext(text, caretIndex) {
    var sourceText = (text || "").toString();
    var safeCaret = Math.max(0, Math.min(caretIndex || 0, sourceText.length));
    var beforeCaret = sourceText.slice(0, safeCaret);
    var triggerIndex = beforeCaret.lastIndexOf("@");

    if (triggerIndex < 0) {
      return null;
    }

    var prefix = beforeCaret.slice(0, triggerIndex);
    if (prefix && !/[\s\r\n]$/.test(prefix)) {
      return null;
    }

    var query = beforeCaret.slice(triggerIndex + 1);
    if (/[\s\r\n]/.test(query)) {
      return null;
    }

    return {
      start: triggerIndex,
      end: safeCaret,
      query: query,
      token: beforeCaret.slice(triggerIndex),
    };
  }

  function appendTrailingSpace(text, insertionEnd, originalText) {
    var suffix = originalText.slice(insertionEnd);
    if (!suffix || /^\s/.test(suffix)) {
      return "";
    }

    return " ";
  }

  function buildMentionKey(member) {
    var displayName = trimLabel(
      (member && member.key) ||
        (member && member.displayName) ||
        getMemberDisplayName(member, "")
    );
    return "@" + displayName;
  }

  function findMentionKeyIndexes(text, mentionKey) {
    var indexes = [];
    var sourceText = (text || "").toString();
    var safeMentionKey = (mentionKey || "").toString();
    var searchIndex = 0;

    if (!safeMentionKey) {
      return indexes;
    }

    while (searchIndex < sourceText.length) {
      var matchIndex = sourceText.indexOf(safeMentionKey, searchIndex);

      if (matchIndex === -1) {
        break;
      }

      indexes.push(matchIndex);
      searchIndex = matchIndex + safeMentionKey.length;
    }

    return indexes;
  }

  function insertMentionAtCaret(text, caretIndex, member) {
    var sourceText = (text || "").toString();
    var safeCaret = Math.max(0, Math.min(caretIndex || 0, sourceText.length));
    var context = findMentionContext(sourceText, safeCaret);
    var mentionKey = buildMentionKey(member);

    if (context) {
      var contextSuffix = sourceText.slice(context.end);
      var mentionInsertion = mentionKey + (contextSuffix && /^\s/.test(contextSuffix) ? "" : " ");
      return {
        text:
          sourceText.slice(0, context.start) + mentionInsertion + contextSuffix,
        mention: {
          key: mentionKey,
          userId: getMentionUserId(member),
          displayName: getMemberDisplayName(member, ANONYMOUS_LABEL),
          type: (member && member.type) || "user",
          all: !!(member && (member.all || member.type === "all")),
        },
        caretIndex: context.start + mentionInsertion.length,
      };
    }

    var trailingSpace = appendTrailingSpace(sourceText, safeCaret, sourceText);
    return {
      text:
        sourceText.slice(0, safeCaret) +
        mentionKey +
        trailingSpace +
        sourceText.slice(safeCaret),
      mention: {
        key: mentionKey,
        userId: getMentionUserId(member),
        displayName: getMemberDisplayName(member, ANONYMOUS_LABEL),
        type: (member && member.type) || "user",
        all: !!(member && (member.all || member.type === "all")),
      },
      caretIndex: safeCaret + mentionKey.length + trailingSpace.length,
    };
  }

  function syncMentionsWithText(text, mentions) {
    var sourceText = (text || "").toString();
    var mentionIndexesByKey = {};
    var mentionCursorByKey = {};

    return toArray(mentions)
      .map(function (entry) {
        return entry && entry.value ? entry.value : entry;
      })
      .filter(function (mention) {
        var mentionUserId = getMentionUserId(mention);

        return !!(
          mention &&
          mention.key &&
          (mention.all || mention.type === "all" || mentionUserId)
        );
      })
      .filter(function (mention) {
        var key = mention.key;
        var matchedIndexes =
          mentionIndexesByKey[key] ||
          (mentionIndexesByKey[key] = findMentionKeyIndexes(sourceText, key));
        var nextCursor = mentionCursorByKey[key] || 0;

        if (nextCursor >= matchedIndexes.length) {
          return false;
        }

        mentionCursorByKey[key] = nextCursor + 1;
        return true;
      })
      .map(function (mention) {
        return {
          key: mention.key,
          userId: getMentionUserId(mention),
          displayName: mention.displayName || ANONYMOUS_LABEL,
          type: mention.type || "user",
          all: !!mention.all || mention.type === "all",
        };
      });
  }

  function getOutgoingMentionLimit() {
    return MAX_OUTGOING_MENTIONS;
  }

  function resolveOutgoingMentions(roomStatus, text, mentions) {
    if (!isLineGroupRoom(roomStatus)) {
      return {
        mentions: [],
        limit: MAX_OUTGOING_MENTIONS,
        exceedsLimit: false,
      };
    }

    var resolvedMentions = syncMentionsWithText(text, mentions);
    var sourceText = (text || "").toString();
    var hasAllMention = resolvedMentions.some(function (mention) {
      return mention && mention.type === "all";
    });

    if (!hasAllMention && /(^|\s)@all\b/i.test(sourceText)) {
      resolvedMentions.unshift({
        key: "@all",
        type: "all",
        all: true,
        displayName: "all",
      });
    }

    return {
      mentions: resolvedMentions,
      limit: MAX_OUTGOING_MENTIONS,
      exceedsLimit: resolvedMentions.length > MAX_OUTGOING_MENTIONS,
    };
  }

  function buildOutgoingMentions(roomStatus, text, mentions) {
    return resolveOutgoingMentions(roomStatus, text, mentions).mentions;
  }

  function buildDisplayName(mention) {
    var first = mention.firstname || '';
    var last = mention.lastname || '';
    var full = [first, last].filter(Boolean).join(' ');
    return full ? '@' + full : null;
  }

  function rebuildMentionSourceText(currentText, mentions) {
    var sourceText = (currentText || '').toString();
    var mentionList = (mentions || []).slice().sort(function (a, b) {
      return ((a && Number(a.index)) || 0) - ((b && Number(b.index)) || 0);
    });
    var offset = 0;

    mentionList.forEach(function (mention) {
      if (!mention) { return; }
      var name = buildDisplayName(mention) || (mention.key || '').toString();
      var key = (mention.key || '').toString();
      var start = (Number(mention.index) || 0) + offset;

      if (!name || !key || start < 0) { return; }
      if (sourceText.slice(start, start + name.length) !== name) { return; }

      sourceText = sourceText.slice(0, start) + key + sourceText.slice(start + name.length);
      offset += key.length - name.length;

      if (!mention.length) {
        mention.length = key.length;
      }
    });

    return sourceText;
  }

  function applyMentions(text, mentions) {
    var sourceText = (text || '').toString();
    var mentionList = mentions || [];
    if (!mentionList.length) {
      return sourceText;
    }
    var sorted = mentionList.slice().sort(function (a, b) { return b.index - a.index; });
    var result = sourceText;
    for (var i = 0; i < sorted.length; i++) {
      var m = sorted[i];
      var name = buildDisplayName(m);
      if (!name || m.index == null || isNaN(Number(m.index)) || m.length == null || isNaN(Number(m.length))) {
        continue;
      }
      result = result.slice(0, m.index) + name + result.slice(m.index + m.length);
    }
    return result;
  }

  return {
    anonymousLabel: ANONYMOUS_LABEL,
    buildOutgoingMentions: buildOutgoingMentions,
    decorateRoomType: decorateRoomType,
    findMentionContext: findMentionContext,
    findCurrentMemberByProfileId: findCurrentMemberByProfileId,
    findMemberByProfileId: findMemberByProfileId,
    getMemberAvatar: getMemberAvatar,
    getLineOAStatus: getLineOAStatus,
    getMemberDisplayName: getMemberDisplayName,
    getSelectableGroupMembers: getSelectableGroupMembers,
    getVisibleGroupMembers: getVisibleGroupMembers,
    getOutgoingMentionLimit: getOutgoingMentionLimit,
    getSenderDisplayName: getSenderDisplayName,
    getSenderInfo: getSenderInfo,
    formatLineGroupRoomLabel: formatLineGroupRoomLabel,
    insertMentionAtCaret: insertMentionAtCaret,
    isLineDirectRoom: isLineDirectRoom,
    isLineGroupRoom: isLineGroupRoom,
    isLineOAActive: isLineOAActive,
    isAnonymousMember: isAnonymousMember,
    isLineRoom: isLineRoom,
    hasSelectableGroupMembers: hasSelectableGroupMembers,
    normalizeMembers: normalizeMembers,
    mergeGroupMemberList: mergeGroupMemberList,
    resolveOutgoingMentions: resolveOutgoingMentions,
    syncMentionsWithText: syncMentionsWithText,
    applyMentions: applyMentions,
    rebuildMentionSourceText: rebuildMentionSourceText,
  };
});
